var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-form-item',{attrs:{"prop":_vm.prop,"label":_vm.label,"label-width":_vm.options.labelWidth,"rules":_vm.rules}},[_c('honjo-file-link',_vm._b({attrs:{"data-source":_vm.value}},'honjo-file-link',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }